import React from "react";

interface Props {
  big?: boolean;
  pathFill?: string;
}
export default function Icon(props: Props) {
  return (
    <svg
      width={props.big ? "74" : "48"}
      height={props.big ? "74" : "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 29.9995C17.1046 29.9995 18 29.1041 18 27.9995C18 26.8949 17.1046 25.9995 16 25.9995C14.8954 25.9995 14 26.8949 14 27.9995C14 29.1041 14.8954 29.9995 16 29.9995Z"
        fill="#262C34"
      />
      <path
        d="M21 29.9995C22.1046 29.9995 23 29.1041 23 27.9995C23 26.8949 22.1046 25.9995 21 25.9995C19.8954 25.9995 19 26.8949 19 27.9995C19 29.1041 19.8954 29.9995 21 29.9995Z"
        fill="#262C34"
      />
      <path
        d="M14 14.9998C15.1046 14.9998 16 14.1043 16 12.9998C16 11.8952 15.1046 10.9998 14 10.9998C12.8954 10.9998 12 11.8952 12 12.9998C12 14.1043 12.8954 14.9998 14 14.9998Z"
        fill="#262C34"
      />
      <path
        d="M18 18.5288C19.1046 18.5288 20 17.6334 20 16.5288C20 15.4242 19.1046 14.5288 18 14.5288C16.8954 14.5288 16 15.4242 16 16.5288C16 17.6334 16.8954 18.5288 18 18.5288Z"
        fill="#262C34"
      />
      <path
        d="M13 19.9995C14.1046 19.9995 15 19.1041 15 17.9995C15 16.8949 14.1046 15.9995 13 15.9995C11.8954 15.9995 11 16.8949 11 17.9995C11 19.1041 11.8954 19.9995 13 19.9995Z"
        fill="#262C34"
      />
      <path
        d="M21 21.9995C22.1046 21.9995 23 21.1041 23 19.9995C23 18.8949 22.1046 17.9995 21 17.9995C19.8954 17.9995 19 18.8949 19 19.9995C19 21.1041 19.8954 21.9995 21 21.9995Z"
        fill="#262C34"
      />
      <path
        d="M29 33.9995C30.1046 33.9995 31 33.1041 31 31.9995C31 30.8949 30.1046 29.9995 29 29.9995C27.8954 29.9995 27 30.8949 27 31.9995C27 33.1041 27.8954 33.9995 29 33.9995Z"
        fill="#262C34"
      />
      <path
        d="M34 33.9995C35.1046 33.9995 36 33.1041 36 31.9995C36 30.8949 35.1046 29.9995 34 29.9995C32.8954 29.9995 32 30.8949 32 31.9995C32 33.1041 32.8954 33.9995 34 33.9995Z"
        fill="#262C34"
      />
      <path
        d="M29 14.9998C30.1046 14.9998 31 14.1043 31 12.9998C31 11.8952 30.1046 10.9998 29 10.9998C27.8954 10.9998 27 11.8952 27 12.9998C27 14.1043 27.8954 14.9998 29 14.9998Z"
        fill="#262C34"
      />
      <path
        d="M33 16.9995C34.1046 16.9995 35 16.1041 35 14.9995C35 13.8949 34.1046 12.9995 33 12.9995C31.8954 12.9995 31 13.8949 31 14.9995C31 16.1041 31.8954 16.9995 33 16.9995Z"
        fill="#262C34"
      />
      <path
        d="M33 21.9995C34.1046 21.9995 35 21.1041 35 19.9995C35 18.8949 34.1046 17.9995 33 17.9995C31.8954 17.9995 31 18.8949 31 19.9995C31 21.1041 31.8954 21.9995 33 21.9995Z"
        fill="#262C34"
      />
      <circle
        cx="36.7321"
        cy="27.7313"
        r="2"
        transform="rotate(-120 36.7321 27.7313)"
        fill="#262C34"
      />
      <circle
        cx="38.7321"
        cy="31.7313"
        r="2"
        transform="rotate(-120 38.7321 31.7313)"
        fill="#262C34"
      />
      <circle
        cx="31.732"
        cy="36.7316"
        r="2"
        transform="rotate(-120 31.732 36.7316)"
        fill="#262C34"
      />
      <circle
        cx="29.5382"
        cy="8.20228"
        r="2"
        transform="rotate(-120 29.5382 8.20228)"
        fill="#262C34"
      />
      <circle
        cx="28.732"
        cy="17.7316"
        r="2"
        transform="rotate(-120 28.732 17.7316)"
        fill="#262C34"
      />
      <circle
        cx="36.7321"
        cy="17.7316"
        r="2"
        transform="rotate(-120 36.7321 17.7316)"
        fill="#262C34"
      />
      <circle
        cx="31.732"
        cy="27.7316"
        r="2"
        transform="rotate(-120 31.732 27.7316)"
        fill="#262C34"
      />
      <circle
        cx="13.7321"
        cy="32.7316"
        r="2"
        transform="rotate(-120 13.7321 32.7316)"
        fill="#262C34"
      />
      <circle
        cx="18.732"
        cy="31.7316"
        r="2"
        transform="rotate(-120 18.732 31.7316)"
        fill="#262C34"
      />
      <path
        d="M25 6L25 41"
        stroke="#252C34"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M42 24L7 24"
        stroke="#252C34"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
